<script setup lang="ts">
import { onMounted } from "vue";
import CanvasButton from "../CanvasButton.vue";
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";
import ToolOptionsDropdown from "./toolbar/ToolOptionsDropdown.vue";
import { DraggerType } from "@/drawing";
import DraggerMenuState from "@/stores/DraggerMenuState";
import { withRestoreSuppressed } from "@/analytics/drawing-analytics";
import {
  hideRulers,
  isRulerToolActive,
  selectRulerTool,
  setRulerVisible,
} from "@/stores/RulerState";

/**
 * Outil Règle : un mode (les règles affichées) et un outil (Origine, qui
 * place leur point (0,0)). Bouton bleu plein tant que l'Origine est
 * sélectionnée, en mode allumé quand un autre outil a pris la main. Son
 * panneau ne fait que masquer les règles ; leur épaisseur se règle dans la
 * modale Affichage (cf. RulerState).
 */

// Plan enregistré avec l'Origine sélectionnée mais les règles masquées
// (réglages d'avant le mode Règle) : l'outil n'a de sens qu'avec les règles.
onMounted(() => {
  if (isRulerToolActive.value && !DraggerMenuState.rulerVisible) {
    withRestoreSuppressed(() => setRulerVisible(true));
  }
});
</script>

<template>
  <ToolOptionsDropdown :owners="[DraggerType.Origin]">
    <template #tool>
      <CanvasButton
        phosphor-icon="ruler"
        :active="isRulerToolActive"
        :mode="DraggerMenuState.rulerVisible"
        :tooltip-title="$t('canvas:tools.ruler.tooltip.title')"
        :tooltip-text="$t('canvas:tools.ruler.tooltip.text')"
        @click="selectRulerTool"
      />
    </template>
    <div class="ruler-panel">
      <button type="button" class="ruler-panel-hide" @click="hideRulers">
        <PhosphorIcon name="eye-slash" :size="16" />
        {{ $t("canvas:tools.ruler.hide") }}
      </button>
    </div>
  </ToolOptionsDropdown>
</template>

<style lang="scss" scoped>
.ruler-panel {
  padding: 4px;
  background-color: var(--canvas-bg);
}

.ruler-panel-hide {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #fff;
  font-size: 13px;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background: var(--canvas-btn-hover-bg);
  }
}
</style>
